/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckErrorContainer } from './PaxCheckErrorContainer';
import {
    PaxCheckErrorContainerFromJSON,
    PaxCheckErrorContainerFromJSONTyped,
    PaxCheckErrorContainerToJSON,
    PaxCheckErrorContainerToJSONTyped,
} from './PaxCheckErrorContainer';
import type { PaxCheckStart1ResponseData } from './PaxCheckStart1ResponseData';
import {
    PaxCheckStart1ResponseDataFromJSON,
    PaxCheckStart1ResponseDataFromJSONTyped,
    PaxCheckStart1ResponseDataToJSON,
    PaxCheckStart1ResponseDataToJSONTyped,
} from './PaxCheckStart1ResponseData';

/**
 * 
 * @export
 * @interface PaxCheckStart1Response
 */
export interface PaxCheckStart1Response {
    /**
     * 
     * @type {PaxCheckStart1ResponseData}
     * @memberof PaxCheckStart1Response
     */
    data?: PaxCheckStart1ResponseData;
    /**
     * 
     * @type {PaxCheckErrorContainer}
     * @memberof PaxCheckStart1Response
     */
    error?: PaxCheckErrorContainer;
}

/**
 * Check if a given object implements the PaxCheckStart1Response interface.
 */
export function instanceOfPaxCheckStart1Response(value: object): value is PaxCheckStart1Response {
    return true;
}

export function PaxCheckStart1ResponseFromJSON(json: any): PaxCheckStart1Response {
    return PaxCheckStart1ResponseFromJSONTyped(json, false);
}

export function PaxCheckStart1ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckStart1Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PaxCheckStart1ResponseDataFromJSON(json['data']),
        'error': json['error'] == null ? undefined : PaxCheckErrorContainerFromJSON(json['error']),
    };
}

export function PaxCheckStart1ResponseToJSON(json: any): PaxCheckStart1Response {
    return PaxCheckStart1ResponseToJSONTyped(json, false);
}

export function PaxCheckStart1ResponseToJSONTyped(value?: PaxCheckStart1Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PaxCheckStart1ResponseDataToJSON(value['data']),
        'error': PaxCheckErrorContainerToJSON(value['error']),
    };
}

